import React from "react";

const About = () => {
  return (
    <div>
      <div className="p-folio__hero" data-aos="fade-down">
        <h1 className="p-folio__title">About Us</h1>
        <p className="p-folio__subtitle">Learn more about Lifetime Infotech</p>

        {/* CATEGORY SELECTOR TABS */}
      </div>

      <section className="abtV1Section">
        <div className="abtV1Container">
          <div className="aboutVaultMedia" data-aos="fade-right">
            <div className="aboutVaultImageBox">
              <img src="/images/hero.jpeg" alt="About Lifetime Infotech" />

              <div className="aboutVaultGlow"></div>
              <div className="aboutVaultRing"></div>
            </div>
          </div>
          {/* <div className="abtV1Media">
            <div className="abtV1ImgBox">
              <img src="/images/ab.jpg" alt="About Us" />
            </div>
          </div> */}

          <div className="abtV1Content" data-aos="fade-left">
            <h2>About Lifetime Infotech</h2>

            <p>
              Lifetime Infotech is a leading software development company
              dedicated to delivering innovative digital solutions for
              businesses around the world. We specialize in building
              high-quality web applications, mobile apps, and enterprise
              software that help businesses grow faster.
            </p>

            <p>
              Our team of experienced developers, designers, and strategists
              work together to create scalable and secure digital products. We
              focus on providing reliable, user-friendly, and performance-
              driven solutions tailored to each client's needs.
            </p>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US */}

      <section className="whyV2Section">
        <div className="whyV2Container">
          <div className="whyV2Content" data-aos="fade-right">
            <h2>Why Choose Us</h2>

            <div className="whyV2Item" data-aos="fade-up" data-aos-delay="100">
              <i className="bi bi-check-circle"></i>
              <p>Affordable pricing</p>
            </div>

            <div className="whyV2Item" data-aos="fade-up" data-aos-delay="200">
              <i className="bi bi-check-circle"></i>
              <p>High quality and scalable solutions</p>
            </div>

            {/* <div className="whyV2Item">
              <i className="bi bi-check-circle"></i>
              <p>Agile development methodology</p>
            </div> */}

            <div className="whyV2Item" data-aos="fade-up" data-aos-delay="300">
              <i className="bi bi-check-circle"></i>
              <p>On-time project delivery</p>
            </div>

            <div className="whyV2Item" data-aos="fade-up" data-aos-delay="400">
              <i className="bi bi-check-circle"></i>
              <p>24/7 customer support</p>
            </div>
          </div>

          {/* <div className="whyV2Image">
            <img src="/images/whychoose.jpg" alt="Why Choose Us" />
          </div> */}
          <div className="whyXImage" data-aos="fade-left">
            <div className="aboutVaultMedia">
              <div className="aboutVaultImageBox1">
                <img src="/images/landing-team.jpg" alt="Why choose us" />

                <div className="whyXGlow"></div>
                <div className="aboutVaultRing"></div>
              </div>
            </div>
            {/* <div className="whyXImageBox">
              <img src="/images/whychoose.jpg" alt="Why choose us" />
              <div className="whyXGlow"></div>
            </div> */}
          </div>
        </div>
      </section>

      {/* MISSION & VISION */}

      <section className="mvV2Section">
        <div className="mvV2Container">
          <div className="mvV2Card" data-aos="zoom-in-up" data-aos-delay="100">
            <div className="mvV2Icon">
              <i className="bi bi-bullseye"></i>
            </div>

            <h3>Our Mission</h3>

            <p>
              Our mission is to empower businesses with innovative and reliable
              technology solutions that improve efficiency, productivity, and
              long-term growth.
            </p>
          </div>

          <div className="mvV2Card" data-aos="zoom-in-up" data-aos-delay="250">
            <div className="mvV2Icon">
              <i className="bi bi-eye"></i>
            </div>

            <h3>Our Vision</h3>

            <p>
              Our vision is to become a trusted global technology partner by
              delivering world-class digital solutions and exceptional customer
              experiences.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
